import React from "react"

const LoadContext = React.createContext(false)

export const LoadContextProvider = LoadContext.Provider
export const useLoadContext = () => React.useContext(LoadContext)
